import { createContext, useContext, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../Helpers/CustomHooks/useLocalStorage";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const [physician, setPhysician] = useLocalStorage("physician", null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiry = () => {
      // Check if user data and token exist
      if (user && user.token) {
        const tokenExpiry = new Date(user.tokenExpiry);
        const currentTime = new Date();

        // Check if the token is still valid
        if (tokenExpiry > currentTime) {
          // Token is still valid, no action needed
          return;
        }
      }

      // Token is expired or user data is not present, log out
      logout();
    };

    // Check token expiry on component mount
    checkTokenExpiry();
  }, [user]);

  // call this function when you want to authenticate the user
  const login = async (data) => {
    setUser(data);
    const decodedPhysicianDetails = jwtDecode(data.token);
    setPhysician(decodedPhysicianDetails);
    navigate("/dashboard");
  };

  // call this function to log out the logged in user
  const logout = () => {
    setUser(null);
    setPhysician(null);
    navigate("/", { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      physician,
      setPhysician,
      login,
      logout,
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
